import MUIMenuIcon from '@mui/icons-material/Menu';

export const MenuIcon = MUIMenuIcon;
